<template>
  <div class="Subpage">
    <Bigmenu
      :NavStatus="Bignav"
      :Way="2"
      :BackPath="'/Adaptive'"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container
      v-if="!Bignav"
      :Type="false"
      :ImgUrl="'b01.png'"
      :Container="Container"
      style="z-index: -6"
    ></Container>
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Container from "@/components/Container.vue";
export default {
  name: "About",
  data() {
    return {
      Bignav: false,
      Container: {
        title: "Ethos智速刀",
        videosrc: "T05.mp4",

        list: [
          {
            body:
              "ETHOS Therapy為全球首台將人工智慧導入自適應放射治療作業流程 ( Adaptive " +
              "Intelligence ) 的直線加速器，並以癌症患者為出發以提供個人化精準治療方案。醫師" +
              "能憑藉此強大的人工智慧核心，針對病患每日的腫瘤變化情形進行處方計畫調整，" +
              "並結合使用多重影像MR、PET、CT及CBCT提供個人化精準醫療，只要15分鐘即可完成" +
              "治療，無須增加額外治療時間。對於大部分的患者及醫院來說，即時自適應個人化精準放射治療( Adaptive Intelligence ) 將不再是夢想與奢望。"
          }
        ]
      }
    };
  },
  components: {
    Back,
    Container,
    Bigmenu
  },
  methods: {
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;
}
</style>
